import {useParams} from "react-router-dom";

import {coralsV2} from "../../services/api/data/coral-types-v2";
// import {fish} from "../../services/api/data/fish-types";

import Navbar from "../layout/navigation/v2/navBar";
import ProductPage from "./productPage";
import ProductPageBanner from "../layout/banner/productPageBanner";
import {inverts} from "../../services/api/data/inverts-types";

// All datasets mapped by product group name
const datasets: Record<string, any[]> = {
    corals: coralsV2,
    inverts
};

// Helper: Merge all products of a full product group
const getAllGroupProducts = (data: any[]) => {
    return data.flatMap(category => [
        ...(category.products || []),
        ...(category.subCategories?.flatMap((sub: any) => sub.products || []) || [])
    ]);
};

// Helper: Merge all products of a single category
const getCategoryProducts = (category: any) => {
    return [
        ...(category.products || []),
        ...(category.subCategories?.flatMap((sub: any) => sub.products || []) || [])
    ];
};

const ProductsWrapper = () => {
    const { productGroup, categoryName, subName } = useParams();

    // 1. Validate productGroup
    const groupKey = productGroup?.toLowerCase();
    const data = datasets[groupKey!];
    console.log("groupKe", groupKey)
    console.log("data", data)
    if (!data) return <div>Invalid product group</div>;

    // INVERTS CASE
    if (groupKey === "inverts") {
        return (
            <>
                <Navbar />
                <ProductPageBanner title="Inverts" />
                <ProductPage products={inverts} />
            </>
        );
    }


    // CASE 1: Only productGroup → show ALL products in group
    if (!categoryName) {
        const products = getAllGroupProducts(data);

        return (
            <>
                <Navbar />
                <ProductPageBanner title={productGroup} />
                <ProductPage products={products} />
            </>
        );
    }

    // 2. Find category
    const category = data.find(
        c => c.name.toLowerCase() === categoryName.toLowerCase()
    );
    if (!category) return <div>Category not found</div>;

    // CASE 2: productGroup/category → show all category products
    if (!subName) {
        const products = getCategoryProducts(category);

        return (
            <>
                <Navbar />
                <ProductPageBanner title={categoryName} />
                <ProductPage products={products} />
            </>
        );
    }

    // CASE 3: productGroup/category/subcategory → show subcategory products
    const subCategory = category.subCategories?.find(
        (s: any) => s.name.toLowerCase() === subName.toLowerCase()
    );

    if (!subCategory) return <div>Subcategory not found</div>;

    return (
        <>
            <Navbar />
            <ProductPageBanner title={subName} />
            <ProductPage products={subCategory.products} />
        </>
    );
};

export default ProductsWrapper;
